/**
 * @param {File} file
 */
const getFileExtension = (file) =>
    file.name.substr(file.name.lastIndexOf(".") + 1).toLowerCase();

export default getFileExtension;
